module.exports = __webpack_public_path__ + "img/google.77f29f96.png";